<template>
  <VApp>
    <SocioBaseNotification />
    <RouterView />
  </VApp>
</template>

<script setup>
import { defineComponent } from "vue";
import SocioBaseNotification from "@/components/sight/SocioBaseNotification.vue";

defineComponent({
  name: "App",
});
</script>

<style>
.v-application .v-divider {
  color: rgb(var(--v-theme-border-color-root));
}

.v-application .socio-btn-toggle .v-btn--active {
  --v-theme-overlay-multiplier: 0;
}
</style>
